export default __webpack_public_path__ + "static/media/cardio2.8ee142c7.png";